import { observer } from 'mobx-react-lite'
import TdCell from './tdCell'
import dashbordStore from '../../store/dashbord'
import { globals } from '../../globals/globals'
import Checkbox from '../ui/checkbox/checkbox'

const TableHeader = observer(
  ({
    items,
    item,
    selectedPositionsStages,
    sort,
    settings = {},
    isAllMod,
    currentStage,
    useSort,
    groupView,
    showSelectCheckbox = true,
    orderId,
    selectedPositionsOrderId
  } ={}) => {
    const onColResize = (name, width) => {
      dashbordStore.changeColumnWith(name, width)
    }


    const getItemsFields = () => {
      return items.map(x => ({
        boxCount: x.position.boxCount,
        blocked: x.blocked,
        id: x.id,
        position_id: x.position.id,
        drawings: x.position.drawings,
        status: x.status,
        title: x.position.title,
        code: x.position.code
      }))
    }

    const isOrderPositionsSelected = orderId === selectedPositionsOrderId

    const clearSelected = () => {
      if (groupView) {
        dashbordStore.clearSelected()
      }
    }

    const selectAllPositions = () => {
      const selectedItemsFileds = getItemsFields()

      if (selectedPositionsStages.length === items.length && !groupView) {
        return dashbordStore.addPositions([])
      }

      if (groupView) {
        dashbordStore.addPositions(selectedItemsFileds, orderId)
      } else {
        dashbordStore.addPositions(selectedItemsFileds)
      }
    }


    const isCheckboxActive = groupView
      ? !!items.length && items.length === selectedPositionsStages.length && orderId === selectedPositionsOrderId
      : !!items.length && items.length === selectedPositionsStages.length

    return (
      <tr className='flex bg-white'>
        <div className='w-[4.8rem] flex items-center py-[0.9rem] px-[1.2rem]'></div>

        {/* <TdCell
                  className="absolute w-[4.8rem] flex items-center">
  
              </TdCell>
              <TdCell
                  checkbox={true}
                  className="w-[4.8rem] flex items-center">
  
              </TdCell> */}
        {Object.entries(settings).map(([key, x]) => {
          if ((!currentStage.stampStage || isAllMod) && key === 'drawings_time') return null
          if ((!currentStage.stampStage || isAllMod) && key === 'custom_work') return null

          if (
            !currentStage.stampStage &&
            currentStage.step !== globals.STEP_SBORKA &&
            currentStage.step !== globals.STEP_KOTGRUZKE &&
            currentStage.step !== globals.STEP_DOSTAVKA &&
            currentStage.id !== null &&  currentStage.id !== undefined &&
            key === 'box_count'
          )
            return null

          if (isAllMod && key == 'status') return null
          if (!isAllMod && key == 'stage') return null
          return (
            <TdCell
              useSort={useSort}
              currentStage={currentStage}
              onColResize={onColResize}
              sort={sort}
              key={key}
              name={key}
              {...x}></TdCell>
          )
        })}
        {showSelectCheckbox && 
                <div className='absolute w-[4.8rem] h-[calc(6rem-1px)] flex items-center py-[0.9rem] px-[1.2rem] bg-[#fff]'>
                <Checkbox
                  active={isCheckboxActive}
                  onChange={isOrderPositionsSelected ? clearSelected : selectAllPositions}></Checkbox>
              </div>
        }

      </tr>
    )
  }
)

export default TableHeader
